import { Backdrop, Box, Typography } from "@mui/material";
import RoomRates from "./RoomRates";
import { useNavigate } from "react-router-dom";
import { usePropertyId } from "../../../../../common/hooks/usePropertyId";
import { withMultipleQueryData } from "../../../../../common/withQueryData";
import { useState } from "react";
import { useRoomsData } from "../../../../../common/hooks/useRoomsData";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";
import { OrdinaryButton } from "../../../../../common/Buttons";
import { useAlertNotification } from "../../../../../common/hooks/useAlertNotification";

const RatesPage = () => {

    const propertyId = usePropertyId();

    const { queryResults: roomsQueryResults } = useRoomsData(propertyId);
    const { queryResults: plansQueryResult } = usePlansData(propertyId);

    return <>
        <Box
            sx={{
                margin: "20px",
            }}>
            <RatesPageContentWithMultipleQueryData
                propertyId={propertyId}
                queryResults={{
                    rooms: roomsQueryResults,
                    plans: plansQueryResult,
                }}
            />
        </Box>
    </>
}

const RatesPageContent = ({ propertyId, queryResults }) => {
    const { setAlert } = useAlertNotification();
    const [editedRoom, setEditedRoom] = useState(null);

    const navigate = useNavigate();

    const { rooms: roomsQueryResult, plans: plansQueryResult } = queryResults;

    /* eslint-disable no-unused-vars */
    const { data: rooms, refetch: reloadRooms } = roomsQueryResult;
    const { data: plans, refetch: reloadPlans } = plansQueryResult;
    /* eslint-enable no-unused-vars */

    const onRatesUpdated = (updatedRates) => {
        setAlert({
            message: "Rates successfully updated!",
            severity: 'success'
        });

        setEditedRoom(null);
    }

    const onError = (error) => {
        setAlert({
            message: error.message,
            severity: 'error'
        });
    }

    const goToRoomsPage = () => {
        navigate('../../rooms');
    }

    const goToPlansPage = () => {
        navigate('../rate-plans');
    }

    const roomsMissing = !rooms?.length;
    const plansMissing = !plans?.length

    if (roomsMissing || plansMissing) {
        return <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
                variant="h6"
                component="div"
                sx={{ margin: '20px', textAlign: 'center' }}
            >
                Create at least one room and one rate plan in order to set the rates
            </Typography>
            <OrdinaryButton sx={{ width: '300px', height: '50px', alignSelf: 'center' }} onClick={roomsMissing ? goToRoomsPage : goToPlansPage} text={`Go to ${roomsMissing ? 'Rooms' : 'Plans'}`} />
        </Box>;
    }

    return <>
        {editedRoom && <Backdrop open sx={{ position: 'fixed', zIndex: 1 }} />}
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>
            {rooms.map((room, index) => <RoomRates
                key={room.id}
                propertyId={propertyId}
                room={room}
                ratePlans={plans} index={index}
                onEdit={() => setEditedRoom(room.id)}
                editing={editedRoom === room.id}
                disabled={editedRoom && editedRoom !== room.id}
                onEditCancel={() => setEditedRoom(null)}
                onEditSuccess={onRatesUpdated}
                onError={onError}
            />)}
        </Box>
    </>
}

const RatesPageContentWithMultipleQueryData = withMultipleQueryData(RatesPageContent)

export default RatesPage;